import React, { useState, useEffect } from 'react';
import SearchSuggestions from './SearchSuggestions';

const HeaderSearchBox = ({
  controller,
  className,
  placeholder,
  suggestionsController,
  onInputChange,
  suggestedResultsLabel,
  allowEmptyQueries = 'true'
}) => {
  const [state, setState] = useState(controller.state);
  const [hasSuggestions, setHasSuggestions] = useState(false);
  const isEnterKey = e => e.key === 'Enter';

  useEffect(() => {
    controller.subscribe(() => {
      setState(controller.state);
    });
    suggestionsController.subscribe(() => {
      if (suggestionsController.state.values.length > 0 && !hasSuggestions)
        setHasSuggestions(true);
      else if (suggestionsController.state.values.length == 0)
        setHasSuggestions(false);
    });
  }, []);

  return (
    <div className={className}>
      <input
        value={state.value}
        onChange={e => {
          onInputChange(e.target.value);
          controller.updateText(e.target.value);
        }}
        onKeyDown={e => {
          if (e.target.value.length === 0 && !(allowEmptyQueries === 'true')) {
            return;
          }
          isEnterKey(e) && controller.submit();
        }}
        placeholder={placeholder}
      />
      <>
        <SearchSuggestions
          suggestedResultsLabel={suggestedResultsLabel}
          controller={suggestionsController}
          text={state.value}
          className="header-search-headlesss__coveo-suggestions-container"
        />
      </>
    </div>
  );
};

export default HeaderSearchBox;
